import { render, staticRenderFns } from "./BannersDetail.vue?vue&type=template&id=5e9d599d&"
import script from "./BannersDetail.vue?vue&type=script&lang=js&"
export * from "./BannersDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports